/**
 * Wrapper for Google Map
 *
 * @param mapElement DOM Element for map.
 * @constructor
 */
function AFMap( mapElement ) {

	/**
	 * Clubs for display.
	 * @type {Array}
	 */
	this.clubs = [];

	/**
	 * Club's markers on the map.
	 * @type {Array}
	 */
	this.markers = [];

	/**
	 * A selected Club by clicking.
	 * @type {object} Club Object
	 */
	this.currentClub = null;

	/**
	 * Information window above the pin.
	 * @type {object} google.maps.InfoWindow
	 */
	this.infoWindow = null;

	/**
	 * Reference to the DOM element.
	 */
	this.mapElement = mapElement;

	/**
	 * jQuery object references to the DOM element.
	 */
	this.$mapElement = jQuery( mapElement );

	/**
	 * Outer handler for click on the 'Get Trial Pass' link.
	 */
	this.getTrialPassCallbak = null;


	/**
	 * Google Map object.
	 * @type {google.maps.Map}
	 */
	this.map = new google.maps.Map( this.mapElement );

	/**
	 * For calculate maps bound.
	 * @type {null}
	 */
	this.resultsBounds = null;

	this.getTrialPassLink = this.getTrialPassLink.bind( this );

	this.$mapElement.on( 'click', '[data-get-trial-pass-link]', this.getTrialPassLink );

	this.modals = {};
}

AFMap.prototype.getModal = function (afNumber) {
	if (!modals[afNumber]) {
		modals[afNumber] = (new AFRedirectToClubSiteModal(afNumber));
	}

	return modals[afNumber]
};

/**
 * Set Clubs Array.
 * @param {array} clubs
 */
AFMap.prototype.setClubs = function( clubs ) {
	let thisObject = this;

	// free Clubs list.
	this.clubs = clubs;

	// remove markers from Google Map.
	this.markers.forEach( function( marker ) {
		marker.setMap( null );
	} );

	// remove markers from this object.
	this.markers = [];

	this.resultsBounds = new google.maps.LatLngBounds();
	this.clubs.forEach( function( club ) {
		let clubMarker,
			clubGoogleLatLng = new google.maps.LatLng( club.lat, club.long ),
			clubMarkerData = club;
		clubMarkerData.position = clubGoogleLatLng;
		clubMarkerData.map = this.map;
		clubMarkerData.animation = google.maps.Animation.DROP;
		clubMarkerData.icon = {
			scaledSize: new google.maps.Size( 35, 51 ),
			url: this.getClubPinImage( club.status )
		};

		clubMarker = new google.maps.Marker( clubMarkerData );

		google.maps.event.addListener( clubMarker, 'mouseover', function() {
			if ( null === thisObject.currentClub || thisObject.currentClub.id !== this.id ) {
				clubMarker.setIcon( thisObject.getClubPinImage( this.status, 'hover' ) );
			}
		} );
		google.maps.event.addListener( clubMarker, 'mouseout', function() {
			if ( null === thisObject.currentClub || thisObject.currentClub.id !== this.id ) {
				clubMarker.setIcon( thisObject.getClubPinImage( club.status ) );
			}
		} );

		google.maps.event.addListener( clubMarker, 'click', function() {
			if ( null === thisObject.currentClub || thisObject.currentClub.id !== this.id ) {

				// hide old
				if ( thisObject.currentClub ) {
					thisObject.currentClub.setIcon( thisObject.getClubPinImage( thisObject.currentClub.status ) );
				}

				// new current
				thisObject.currentClub = this;
				thisObject.map.panTo( thisObject.currentClub.position );
				thisObject.openInfoWindow( this );

				this.setIcon( thisObject.getClubPinImage( this.status, 'active' ) );

				dataLayer.push( {
					'event': 'map',
					'address': this.address,
					'address2': this.address2,
					'afNumber': this.id,
					'city': this.city,
					'latitude': this.latitude,
					'longitude': this.longitude,
					'phoneNumber': this.phone,
					'postCode': this.zip,
					'post_title': this.title,
					'stateProvince': this.stateAbbr,
					'distance': this.distance // already with miles/kilometers
				} );
			}
		} );

		this.markers.push( clubMarker );
		this.resultsBounds.extend( clubGoogleLatLng );
	}, this );
	this.map.fitBounds( this.resultsBounds );

};

AFMap.prototype.getClubPinImage = function( clubStatus, pinState ) {
	if ( AFClubStatus.NORMAL === clubStatus ) {
		if ( 'hover' === pinState ) {
			return dynamicURLs.stylesheetDirectoryURI + '/img/map-pin-hover.png';
		} else if ( 'active' === pinState ) {
			// the same as 'hover'
			return dynamicURLs.stylesheetDirectoryURI + '/img/map-pin-hover.png';
		} else {
			return dynamicURLs.stylesheetDirectoryURI + '/img/map-pin.png';
		}
	} else {
		if ( 'hover' === pinState ) {
			return dynamicURLs.stylesheetDirectoryURI + '/img/map-pin-hover-grey.png';
		} else if ( 'active' === pinState ) {
			// the same as 'hover'
			return dynamicURLs.stylesheetDirectoryURI + '/img/map-pin-hover-grey.png';
		} else {
			return dynamicURLs.stylesheetDirectoryURI + '/img/map-pin-grey.png';
		}
	}
};

/**
 * Open a popup club information window.
 * @param clubMarker
 */
AFMap.prototype.openInfoWindow = function( clubMarker ) {
	let thisObject = this,
		infoWindowContent,
		clubStatusText = '',
		clubAddressFormated,
		addressTemplate = '{{address}} {{address2}}<br />{{city}}, {{state_abbr}}';

	// close previous
	if ( this.infoWindow ) {
		this.infoWindow.close();
	}

	if ( AFClubStatus.COMING_SOON === clubMarker.status ) {
		clubStatusText = translations.comingSoon;
	} else if ( AFClubStatus.OPENING_SOON === clubMarker.status ) {
		clubStatusText = translations.openingSoon;
	}

	if ( mapGlobalOptions.address_format ) {
		jQuery.each( mapGlobalOptions.address_format, function() {
			if ( this.country_select === clubMarker.countryAbbr ) {
				addressTemplate = this.format;
			}
		} );
	}

	clubAddressFormated = addressTemplate
		.replace( '{{address}}', clubMarker.address )
		.replace( '{{address2}}', clubMarker.address2 )
		.replace( '{{city}}', clubMarker.city )
		.replace( '{{state}}', clubMarker.state )
		.replace( '{{state_abbr}}', clubMarker.stateAbbr )
		.replace( '{{zip}}', clubMarker.zip )
		.replace( '{{country_abbr}}', clubMarker.countryAbbr )
	;

	infoWindowContent =
		'<div class="infowindow-content" data-club-id="'+clubMarker.id +'">' +
		'	<span class="name link-text"><a href="' + clubMarker.url + '">' + clubMarker.title + (clubStatusText ? ' ' + clubStatusText : '') + '</a></span>' +
		'	<span class="address">' + clubAddressFormated + '</span>' +
		'	<span class="phone">' + clubMarker.phone + '</span>' +
		'	<span class="links link-text">' +
		'		<a target="_blank" href="' + clubMarker.passUrl + '" data-get-trial-pass-link>' + translations.getTrialPass + '</a> | ' +
		'		<a class="linkVisitGym" href="' + (clubMarker.isLocalClub ? clubMarker.getVisitGymUrl() : '#') + '">' + (clubMarker.isLocalClub ? translations.visitThisGym : translations.visitAnytimeFitnessCountry.replace('{country_name}', translations.countries[clubMarker.countryAbbr])) + '</a>' +
		'	</span>' +
		'</div>';

	this.infoWindow = new google.maps.InfoWindow( {
		content: infoWindowContent,
		marker: clubMarker.id
	} );

	if (!clubMarker.isLocalClub) {
		jQuery(`.infowindow-content[data-club-id="${clubMarker.number}"]`).on('click', '.linkVisitGym', (e) => {
			e.preventDefault();
			this.getModal(clubMarker.name).show();
		});
	}

	this.infoWindow.open( this.map, clubMarker );

	google.maps.event.addListener( this.infoWindow, 'closeclick', function() {
		thisObject.currentClub.setIcon( thisObject.getClubPinImage( thisObject.currentClub.status ) );
	} );

};

AFMap.prototype.setGetTrialPassCallbak = function( callback ) {
	this.getTrialPassCallbak = callback;
};

AFMap.prototype.getTrialPassLink = function( e ) {
	if ( this.getTrialPassCallbak ) {
		e.preventDefault();
		this.getTrialPassCallbak( this.currentClub );
	}
};

AFMap.prototype.show = function() {
	google.maps.event.trigger( this.map, 'resize' );
	this.map.fitBounds( this.resultsBounds );
};

AFMap.prototype.destroy = function() {
	// remove
	this.$mapElement.off( 'click', '[data-get-trial-pass-link]', this.getTrialPassLink );
	delete this;
};
